import { EntityType } from '@frontend/common';
import { IdentificationClient } from '@frontend/identification/api';
import { IdentificationType } from '@frontend/identification/types';
import { IoTClient } from '@frontend/iot/api';
import { IoT } from '@frontend/iot/types';
import { useModals } from '@frontend/modal';
import { refresh, useAccountRepository } from '@frontend/repository';
import { Change, ChangeStatus } from '@frontend/sync/types';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../redux/store';

interface ViewProps {
    api: string | undefined;
    currentAccount: string | null;
    dispatch: ReturnType<typeof useAppDispatch>;
    iot: IoT | null;
    selectedChange: Change | null;
    setSelectedChange: Dispatch<SetStateAction<Change | null>>;
    iotIdentifier: string | null;
    status: string | null;
    setStatus: Dispatch<SetStateAction<string | null>>;
    listId: string;
    openModal: ReturnType<typeof useModals>['openModal'];
    IOT_DATA_MODAL_ID: string;
}

const useIoTSeedOverview = (): ViewProps => {
    const { iotId, api } = useParams();
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const { openModal } = useModals();
    const IOT_DATA_MODAL_ID = 'iot-data-modal';
    const listStore = useAppSelector((state) => state.lists);
    const listId = 'iot-seed-changes-overview-list';
    const [iot, setIot] = useState<IoT | null>(null);
    const [iotIdentifier, setIotIdentifier] = useState<string | null>(null);
    const [selectedChange, setSelectedChange] = useState<Change | null>(null);
    const [status, setStatus] = useState<string | null>(ChangeStatus.PENDING);
    useEffect(() => {
        if (!iotId || !currentAccount) return;
        IoTClient.fetchIoT(currentAccount, iotId).then((res) => {
            setIot(res);
            IdentificationClient.fetchIdentifications({ entity_id: res.id, entity_type: EntityType.IOT, type: IdentificationType.IOT }).then((res) => {
                if (res.results.length > 0) {
                    setIotIdentifier(res.results[0].key);
                }
            });
        });
    }, [currentAccount, iotId]);

    useEffect(() => {
        if (!listStore[listId]) return;
        dispatch(refresh({ listId: listId, refresh: true }));
    }, [status]);
    return {
        api,
        currentAccount,
        dispatch,
        iot,
        selectedChange,
        setSelectedChange,
        iotIdentifier,
        status,
        setStatus,
        listId,
        openModal,
        IOT_DATA_MODAL_ID
    };
};

export default useIoTSeedOverview;
